import { FC } from "react";

import type { EvalSpec } from "@tsmono/inspect-common/types";

import styles from "./PrintHeading.module.css";

interface PrintHeadingProps {
  evalSpec?: EvalSpec;
}

export const PrintHeading: FC<PrintHeadingProps> = ({ evalSpec }) => {
  const task = evalSpec?.task || "Unknown Task";
  const model = evalSpec?.model || "Unknown Model";
  const time = evalSpec?.created
    ? new Date(evalSpec.created).toLocaleString()
    : "Unknown Time";

  return (
    <div className={styles.heading}>
      <div className={styles.headingTask}>{task}</div>
      <div className={styles.headingModel}>{model}</div>
      <div className={styles.headingTime}>{time}</div>
    </div>
  );
};
